import { render, staticRenderFns } from "./TemplateDrawingDetail.vue?vue&type=template&id=fcc2f1d6"
import script from "./TemplateDrawingDetail.vue?vue&type=script&lang=js"
export * from "./TemplateDrawingDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports